const routes = [
  {
      path: '/',
      component: () => import('@/pages/pay/pay'),   //支付界面
      meta: { title: '向商家付款' }
  },
  {
      path: '/pay',
      component: () => import('@/pages/pay/pay'),   //支付界面
      meta: { title: '向商家付款' }
  },

  {
      path: '/paymanage',
      component: () => import('@/pages/paymanage/paymanage'),   //实施发起客户支付h5(天美云后台小程序-客服--发起订单 )
      meta: { title: '天美联盟软件' }
  },



  {
      path: '/paystatus',
      component: () => import('@/pages/paystatus/paystatus'),   //支付成功/支付失败
      meta: { title: '天美支付扫码支付' }
  },
  {
      path: '/zfbAuth',
      component: () => import('@/pages/zfbAuth/zfbAuth'),   //支付成功/支付失败
      meta: { title: '支付宝授权' }
  },

   {
      path: '/memberAuth',
      component: () => import('@/pages/zfbAuth/memberAuth'),   //成功/失败
      meta: { title: '碰一碰会员授权' }
  },
  {
      path: '/unableplat',
      component: () => import('@/pages/unableplat/unableplat'),  //不支持平台
      meta: { title: '天美支付扫码支付' }
  },
  {
      path: '*',
      component: () => import('@/pages/page404/index'),  //404页面
      meta: { title: '天美支付扫码支付' }
  },
  {
      path: '/404',
      component: () => import('@/pages/page404/index'),  //404页面
      meta: { title: '天美支付扫码支付' }
  }
]

export default routes